<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormComisionesxBanco" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="form-group row" v-if="MostrarComisiones">
                                <div v-for="(item,index) in Comisiones" :key="index" class="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 mb-1">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" v-model="ComisionesSeleccionadas" :value="item" :id="'chk'+index">
                                        <label class="form-check-label" :for="'chk'+index">
                                            {{ item.Cantidad }}%
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div v-if="Comisiones.length==0" style="height: 100px;">
                    <h6 class="text-center">Sin Comisiones</h6>
                </div>
            </div>
        </template>
    </CLoader>
</template>

<script>
export default {
    name: 'FormCategoriaGaleria',
    props: ['poBtnSave','pComisiones','pComisionesLista','pIdBancoImagen'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
                Obj:{}
            },
            Comisiones:[],
            ComisionesSeleccionadas:[],
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            MostrarComisiones:false
        }
    },
    methods :
    {
       	async Guardar()
        {
            let valor = this.ComisionesSeleccionadas.sort(function (a, b) {
                return a.Cantidad - b.Cantidad;
            });

            this.bus.$emit('TraerComisionesSeleccionadas',valor,this.Comisiones);
            this.bus.$emit('CloseModal_'+this.Emit);
        },
		Recuperar()
        {
            this.MostrarComisiones=false
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            if (this.pComisionesLista.length==0) {
                this.$http.get(
                    "/comisionesSimple"
                    ).then((res) => {
                    this.Comisiones = res.data.data;
                    if (this.pIdBancoImagen==0) {
                        this.Comisiones.map((element)=>{
                            return element.Precio=0;
                        });
                    }
                    else{
                        this.Comisiones.forEach(element=>{
                        this.ComisionesSeleccionadas.some(
                            (el)=>{return el.IdComision==element.IdComision ? element.Precio=el.Precio : element.Precio=0})
                        })
                    }
                    this.MostrarComisiones=true;
                    }).finally(()=>{
                    this.ConfigLoad.ShowLoader = false;
                    this.MostrarComisiones=true;
                });
            }
            else{
                this.Comisiones=this.pComisionesLista
                // if (this.ComisionesSeleccionadas.length>0) {
                //     this.Comisiones.forEach(element=>{
                //         this.ComisionesSeleccionadas.some(
                //             (el)=>{return el.IdComision==element.IdComision ? element.Precio=el.Precio : element.Precio=0})
                //     })
                // }
                this.Comisiones.forEach(element => {
                    let Precio=0;
                    let bndCambio=this.pComisionesLista.some(el=>{
                        // if(el.IdComision==element.IdComision){
                        //     element.Precio=el.Precio
                        // }
                        Precio=el.Precio
                        return el.IdComision==element.IdComision
                    })
                    if (bndCambio) {
                        element.Precio=Precio;
                    }
                });
                this.ConfigLoad.ShowLoader = false;
                this.MostrarComisiones=true;
            }
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.Recuperar();
            if (this.pComisiones.length>0) {
                this.ComisionesSeleccionadas=this.pComisiones;
            }

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
        });
    }
}
</script>